import billingAddressPage from '../pages/BillingAddressPage/BillingAddressPageReducer';
import cycoPage from '../pages/CycoPage/CycoPageReducer';
import personalInformationPage from '../pages/PersonalInformationPage/PersonalInformationPageReducer';
import showDoubleConsent from '../pages/TermsPage/TermsPageReducer';

// all reducers required for Pages in the US need to be listed here
// note that the name you use is where the related data will be stored
export const reducersUS = {
    billingAddressPage,
    cycoPage,
    personalInformationPage,
    showDoubleConsent
};
